import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertEntryOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getEntryOperationList,
    setIsInsertModalOpen,
    setInsertLoading,
    payload,
  ) => {
    axiosClient
      .post(`Operation/Entry/Insert`, {
        zoneGuid: payload.zoneGuid,
        title: payload.title,
        description: payload.description,
        voucherType: payload.voucherType,
        counterpartID: payload.counterpartID,
        voucherID: payload.voucherID,
        invoiceNumber: payload.invoiceNumber,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getEntryOperationList?.();
          setIsInsertModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading?.(false));
  };

  return { insertRequest };
};

export default useInsertEntryOperation;
